import Big from "big.js";
import store from "../store";
import { labelForCode, codeFromHasTax } from "./taxCatalog";

const PurchaseItem = class {
    constructor(object) {
        if (object === undefined) {
            this.id = null
            this.code = null
            this.productId = null
            this.product = null;
            this.hasTax = false;
            this.ivaCode = '0';
            this.iceCode = null;
            this.iceValue = new Big('0.0');
            this.amount = new Big('0.0');
            this.discount = new Big('0.0');
            this.readableDiscount = new Big('0.0');
            this.unitPrice = new Big('0.0');
        } else {
            this.id = object.id || null;
            this.code = object.code || null;
            this.productId = object.productId;
            this.product = object.product;
            this.hasTax = object.hasTax;
            this.ivaCode = object.ivaCode || codeFromHasTax(object.hasTax, store.getters.business.taxPercentage);
            // ICE congelado del item (lo calcula el backend desde el producto).
            this.iceCode = object.iceCode || null;
            this.iceValue = (object.iceValue !== undefined && object.iceValue !== null) ? new Big(object.iceValue) : new Big('0.0');
            this.amount = (object.amount !== undefined) ? new Big(object.amount) : new Big('1.0');
            this.discount = (object.discount !== undefined) ? new Big(object.discount) : new Big('0.0');
            this.readableDiscount = this.discount.times(100).round(2);
            this.unitPrice = (object.unitPrice !== undefined) ? new Big(object.unitPrice) : new Big('0.0');
        }
        this.readableTax = labelForCode(this.ivaCode);
    }

    get totalPrice() {
        return this.unitPrice.times(this.amount).times(this.discount.times(-1).plus(1)).round(2);
    }
}

export default PurchaseItem